<script setup lang="ts">
import { useRoute } from 'vue-router'

definePageMeta({
  layout: 'blog',
})

const route = useRoute()

// const contentQuery = await queryContent('blog')
//   .where({ _path: route.path })
//   .findOne()
</script>

<template>
  <div class="container">
    <!--      v-if="contentQuery?.thumbnail" -->
    <div class="thumbnail-container" />
    <article class="py-8">
      <ContentDoc>
        <template #not-found>
          Sorry not found this post
        </template>
      </ContentDoc>
    </article>
  </div>
</template>

<style scoped>
:deep(h1) {
  @apply mb-4 text-3xl font-bold text-neutral-950 dark:text-neutral-50;
}

:deep(h2) {
  @apply mb-2 text-2xl font-semibold text-neutral-950  dark:text-neutral-50;
}

:deep(li),
:deep(p),
:deep(span) {
  @apply mb-4 text-base text-neutral-900 dark:text-neutral-50;
}

:deep(li) {
  @apply list-inside list-disc;
}

:deep(pre) {
  @apply overflow-x-auto rounded-md bg-black p-6 dark:bg-[rgba(0,0,0,.5)];
}
</style>
